"use client";

import { MultiSelect, type OptionType } from "@oreme/ui";
import { useSetAtom, useAtomValue, useAtom } from "jotai";
import { useLocale, useTranslations } from "next-intl";
import React, { type ReactElement } from "react";
import { MultiValue } from "react-select";
import {
  selectedObservatoryAtom,
  selectedTagIdsAtom,
  tagsAtom,
} from "@/store/sites";

function SitesTagSelect(): ReactElement {
  const locale = useLocale();
  const t = useTranslations("sites.TagSelect");

  const tags = useAtomValue(tagsAtom);
  const [selectedTagIds, setSelectedTagIds] = useAtom(selectedTagIdsAtom);
  const setSelectedObservatory = useSetAtom(selectedObservatoryAtom);

  let options = tags.map((tag) => ({
    label: tag.name[locale],
    value: tag.id,
  }));
  options = options.sort((a, b) => a.label.localeCompare(b.label));

  const defaultValue = options.filter(({ value }) =>
    selectedTagIds.includes(value),
  );

  const handleChange = (newValue: MultiValue<OptionType>) => {
    if (selectedTagIds.length === 0) {
      setSelectedObservatory(null);
    }

    const newSelectedTagIds = newValue.map(({ value }) => Number(value));
    setSelectedTagIds(newSelectedTagIds);
  };

  return (
    <div className="flex flex-col gap-1">
      <header className="flex flex-row justify-between items-center min-h-6">
        <h3 className="text-xs">{t("title")}</h3>
      </header>
      <MultiSelect<true>
        unstyled={true}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        className="relative z-50 w-full"
        defaultValue={defaultValue}
        value={defaultValue}
        onChange={handleChange}
        options={options}
        placeholder={t("searchPlaceholder")}
        noOptionsMessage={() => t("noOptionsMessage")}
        menuPlacement="auto"
        menuPortalTarget={
          globalThis.window === undefined ? null : document.body
        }
        isMulti
        isSearchable
      />
    </div>
  );
}

export default SitesTagSelect;
